// Formula Analyzer — API client for POST /api/v1/formula/explain.
// Isolated feature file: safe to delete for a full revert.

import { api } from './api';

export interface FormulaStep {
  expr: string;
  value: string;
  explain: string;
}

export interface FormulaExplanation {
  title: string;
  formula: string;
  family: string;
  steps: FormulaStep[];
  result: string;
  summary: string[];
}

export async function explainFormula(
  formula: string,
  sample_context = '',
): Promise<{ explanation: FormulaExplanation; credits_remaining?: number }> {
  const { data } = await api.post(
    '/api/v1/formula/explain',
    { formula, sample_context },
    { timeout: 45_000 },
  );
  return data;
}
